<h2>Category Data Mapping</h2>

<div class="px-2 py-3 contents h-full max-h-80" *ngIf="isLoadCategoryMappingGridDataSource">
    <div class="flex pb-4 justify-start">
        <dx-check-box [value]="false" text="Include deactivated Category Mapping items" class="pr-2" (onValueChanged)="extraFilteringOptionsChange('Active', $event)"></dx-check-box>
    </div>
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid
            #categoryMappingDataGrid
            id="categoryMappingDataGrid"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [dataSource]="categoryMappingDataSource"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true"
            [hoverStateEnabled]="true"
            [(selectedRowKeys)]="categoryMappingSelectedRowMap"
            (onSelectionChanged)="selectionMappingDataChangedHandler()"
            (onContentReady)="onReady($event)"
            (onContextMenuPreparing)="categoryMappingDataGridContextMenu($event)"
            keyExpr="CategoryMappingId"
        >
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadMappingState"
                    [customSave]="saveMappingState">
            </dxo-state-storing>
            <dxo-load-panel
                    [enabled]="false"
                    shadingColor="rgba(0,0,0,0.4)"
                    [showIndicator]="true"
                    [showPane]="true"
                    [shading]="true">
            </dxo-load-panel>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="[5, 10, 25, 50, 100]"
                    displayMode="compact"
                    [showPageSizeSelector]="true"
                    [showNavigationButtons]="false"
            >
            </dxo-pager>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>

            <dxi-column dataField="CategoryMappingId" [allowHeaderFiltering]="false" [width]="140" caption="Category Mapping Id" [customizeText]="customizeCategoryMappingId"></dxi-column>
            <dxi-column caption="Action" [allowHeaderFiltering]="false" cellTemplate="action" alignment="center"></dxi-column>
            <dxi-column caption="Source Data">
                <dxi-column dataField="DataProviderCode" caption="Data Provider Code">
                    <dxo-header-filter [dataSource]="dataProviderCodeHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SourceCategory" [allowHeaderFiltering]="false" caption="Category"></dxi-column>
            </dxi-column>

            <dxi-column dataField="MappingModeName" caption="Mapping Mode">
                <dxo-header-filter [dataSource]="mappingModeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column caption="Mapping Counts">
                <dxi-column dataField="TotalCount">
                    <dxo-header-filter [dataSource]="totalCountHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="NewCount" caption="New">
                    <dxo-header-filter [dataSource]="newHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="MapCount" caption="Map">
                    <dxo-header-filter [dataSource]="mapHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SaveCount" caption="Save">
                    <dxo-header-filter [dataSource]="saveHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="OmitCount" caption="Omit">
                    <dxo-header-filter [dataSource]="omitHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="IsInconsistentMappingMessage" caption="Inconsistency">
                    <dxo-header-filter [dataSource]="inconsistencyHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="Mapped to">
                <dxi-column dataField="CategoryId" caption="Category Id" [visible]="false">
                    <dxo-header-filter [dataSource]="categoryIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SubcategoryFunctionName" caption="Subcategory Function">
                    <dxo-header-filter [dataSource]="subcategoryFunctionNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>

                <dxi-column dataField="SubcategoryFormName" caption="Subcategory Form">
                    <dxo-header-filter [dataSource]="subcategoryFormNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="Data auditing">
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created by" [visible]="false">
                    <dxo-header-filter [dataSource]="createdByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedOn" caption="Create on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified by" >
                    <dxo-header-filter [dataSource]="modifiedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedOn" caption="Modified on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="modifiedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed by" [visible]="false">
                    <dxo-header-filter [dataSource]="reviewedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedOn" caption="Reviewed on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>

            <dxi-column dataField="Active" caption="Is Active" [visible]="false"></dxi-column>

            <div *dxTemplate="let action of 'action'">
                <dx-button class="mr-1" icon="fas fa-ban fa-1x" hint="Omit" [disabled]="action?.data?.MappingModeId == 3" (onClick)="omit(action?.data?.CategoryMappingId)"></dx-button>
                <dx-button class="mr-1" icon="far fa-bookmark fa-1x" hint="Save" [disabled]="action?.data?.MappingModeId == 2" (onClick)="save(action?.data?.CategoryMappingId)"></dx-button>
                <dx-button
                        id="btnAccept"
                        *ngIf="action?.data?.ModifiedByUserId <= 0 && action?.data?.MappingModeId == 0"
                        class="mr-1"
                        icon="fa fa-check fa-1x"
                        hint="Accept"
                        (onClick)="accept(action?.data?.CategoryMappingId)"
                ></dx-button>
                <dx-button
                        id="btnReview"
                        class="mr-1"
                        *ngIf="action?.data?.ModifiedByUserId > 0 && action?.data?.ModifiedByUserId != currentUser?.UserId && action?.data?.ReviewedByUserId == -1"
                        icon="fas fa-check-double fa-1x"
                        hint="Review"
                        (onClick)="review(action?.data?.CategoryMappingId)"
                ></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Deactivate" (onClick)="deactivate(action?.data?.CategoryMappingId)"></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && !action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Reactivate" (onClick)="deactivate(action?.data?.CategoryMappingId)"></dx-button>
            </div>
            <dxo-paging [pageSize]="5"></dxo-paging>
        </dx-data-grid>
    </div>
</div>

<div class="py-3 block h-full" *ngIf="isLoadCategoryMasterGridDataSource">
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid
            #categoryMasterDataGrid
            id="categoryMasterDataGrid"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [dataSource]="categoryMasterDataSource"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true"
            [hoverStateEnabled]="true"
            [(selectedRowKeys)]="categoryMasterSelectedRowMap"
            (onSelectionChanged)="selectionMasterDataChangedHandler()"
            (onContextMenuPreparing)="categoryMasterDataGridContextMenu($event)"
            keyExpr="RowId"
        >
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadMasterState"
                    [customSave]="saveMasterState">
            </dxo-state-storing>
            <dxo-load-panel
                [enabled]="false"
                shadingColor="rgba(0,0,0,0.4)"
                [showIndicator]="true"
                [showPane]="true"
                [shading]="true">
            </dxo-load-panel>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-pager
                [visible]="true"
                [allowedPageSizes]="[5, 10, 25, 50, 100]"
                displayMode="compact"
                [showPageSizeSelector]="true"
                [showNavigationButtons]="false"
            >
            </dxo-pager>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-search-panel
                [visible]="true"
                [(text)]="searchText"
            ></dxo-search-panel>
            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>

            <dxi-column dataField="RowId" [allowHeaderFiltering]="false" [width]="140" caption="Category Roster Id" [customizeText]="customizeCategoryMasterId"></dxi-column>
            <dxi-column caption="Action" [allowHeaderFiltering]="false" [width]="90" cellTemplate="action" alignment="center"></dxi-column>
            <dxi-column dataField="CategoryName" caption="Category">
                <dxo-header-filter [dataSource]="masterCategoryNameDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="SubcategoryFunctionName" caption="Subcategory Function">
                <dxo-header-filter [dataSource]="masterSubcategoryFunctionNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="SubcategoryFormName" caption="Subcategory Form">
                <dxo-header-filter [dataSource]="masterSubcategoryFormNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>

            <div *dxTemplate="let action of 'action'">
                <dx-button
                    class="mr-1"
                    icon="fas fa-map-marker-alt fa-1x"
                    hint="Map"
                    (onClick)="map(action?.data?.CategoryId, action?.data?.SubcategoryFormRelationId, action?.data?.SubcategoryFunctionRelationId)"
                ></dx-button>
            </div>
            <dxo-paging [pageSize]="5"></dxo-paging>
        </dx-data-grid>
    </div>
</div>
